export default class StyledFileUpload {
  element;
  defaultText;
  removeText;
  placeholder;
  wrapper;
  trigger;
  removeTrigger;

  gfField;
  gfRemoveTrigger;
  gfFiles = [];

  constructor({
    element,
    defaultText = "Upload a file",
    removeText = "Remove",
  }) {
    if (!element || element.dataset.styledFileUploadInitialized) {
      return;
    }

    this.element = element;
    this.element.dataset.styledFileUploadInitialized = true;
    this.defaultText = defaultText;
    this.removeText = removeText;
    this.initialize();
  }

  /**
   * initialize all file inputs on the page
   */
  static init({
    selector = 'input[type="file"]',
    defaultText = "Upload a file",
    removeText = "Remove",
  } = {}) {
    const fileInputs = document.querySelectorAll(selector);
    [...fileInputs].forEach(
      (element) => new StyledFileUpload({ element, defaultText, removeText })
    );
  }

  /**
   * replace the element with a custom trigger
   */
  initialize() {
    const trigger = document.createElement("div");
    trigger.classList.add("file-upload-trigger");
    trigger.innerHTML = `
      <span class="icon"></span>
      <span class="placeholder">${this.defaultText}</span>
      <span class="remove" title="${this.removeText}"> &times; </span>
    `;
    this.trigger = trigger;
    this.placeholder = this.trigger.querySelector(".placeholder");
    this.removeTrigger = this.trigger.querySelector(".remove");

    const wrapper = document.createElement("label");
    wrapper.classList.add("file-upload-wrapper");
    this.element.insertAdjacentElement("beforebegin", wrapper);
    wrapper.append(this.element);
    wrapper.append(this.trigger);
    this.wrapper = wrapper;

    this.gfField = this.element.closest(".ginput_container_fileupload");
    if (this.gfField) {
      this.gfRemoveTrigger = this.gfField.querySelector(".gform_delete");
      if (this.gfRemoveTrigger) {
        const parent = this.gfRemoveTrigger.parentElement;
        this.gfFiles = [parent.innerText.trim()];
        parent.style.display = "none";
      }
    }

    this.updateText();
    this.addEventListeners();
  }

  /**
   * update the trigger text
   */
  updateText() {
    if (this.gfFiles.length) {
      this.placeholder.innerText = this.gfFiles[0];
      this.wrapper.classList.add("has-file");
      return;
    }

    const files = this.element.files;
    if (files.length) {
      this.placeholder.innerText = files[0].name;
      this.wrapper.classList.add("has-file");
    } else {
      this.placeholder.innerText = this.defaultText;
      this.wrapper.classList.remove("has-file");
    }
  }

  /**
   * listen to events
   */
  addEventListeners() {
    // change the file name
    this.element.addEventListener("change", (e) => {
      const files = this.element.files;
      if (files.length) {
        this.gfFiles = [];
      }
      this.updateText();
    });

    // remove the file
    this.removeTrigger.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      // remove the Gravity forms file
      if (this.gfRemoveTrigger) {
        this.gfRemoveTrigger.click();
        this.gfFiles = [];
      }

      this.element.value = "";
      this.element.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
}
